exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".codentify-camera-img{width:4em;display:block;margin-top:.5em}.list-sku-header,.list-sku-header .column-icon,.list-sku-header .column-icon .q-icon{border-color:#979797!important;color:#979797!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8af97bee","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/courier/stock-order/_stockOrderDetail.vue
// module id = OO9X
// module chunks = 83